import _pickBy from 'lodash/pickBy';
import _identity from 'lodash/identity';


export default obj => _pickBy(obj, _identity);
